import BaseCommand from "@/models/api/commands/BaseCommand";

export class RemoveContractComponentCommand extends BaseCommand {
  CommandName = "RemoveContractComponent";
  constructor(sessionId: string, operationId: string) {
    super(sessionId, operationId);
  }
}
